import CurrentUserEmpty from "./CurrentUserEmpty";

export default class CurrentUserPresent {

    constructor(userField, documents, currentUser) {
        this.emptyCondition = new CurrentUserEmpty(userField, documents, currentUser)
    }

    test() {
        console.log('CurrentUserPresent.test')
        return !this.emptyCondition.test()
    }
}